import { combineReducers } from '@reduxjs/toolkit';

import { appReducer } from './app';
import { serverReducer } from './server';

export const rootReducer = combineReducers({
  server: serverReducer,
  app: appReducer,
});
